import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core'
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { ApolloClients, DefaultApolloClient } from '@vue/apollo-composable'
import { sha256 } from 'crypto-hash'
import possibleTypesResult from '~/api/graphql/possibleTypes'

/**
 * In-house replacement for @nuxtjs/apollo: creates the Drupal Apollo client
 * per app instance (per request on the server) and provides it for
 * @vue/apollo-composable (useMutation) and the typed helpers in
 * ~/lib/utils/graphqlDocument.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  const httpLink = new HttpLink({
    uri: `${config.public.drupalApiUrl}/graphql`,
    headers: {
      ...(config.public.drupalAuthHeader ? { Authorization: config.public.drupalAuthHeader } : {}),
    },
  })

  const client = new ApolloClient({
    link: createPersistedQueryLink({ sha256 }).concat(httpLink),
    cache: new InMemoryCache({ possibleTypes: possibleTypesResult.possibleTypes }),
    ssrMode: import.meta.server,
    devtools: { enabled: import.meta.dev && import.meta.client },
  })

  const clients = { default: client }
  nuxtApp.vueApp.provide(ApolloClients, clients)
  nuxtApp.vueApp.provide(DefaultApolloClient, client)

  return {
    provide: {
      apolloClients: clients,
    },
  }
})
